import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <header 
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            <div className="flex items-center">
              <a href="https://www.mustsafe.co.kr/" target="_blank" rel="noopener noreferrer">
                <img 
                  src="https://static.readdy.ai/image/f2d4f0b55ceaa6c07b19f5a03d25a420/3fad4718bb9782d32326554ad714f614.png" 
                  alt="중대안전보건예방협회" 
                  className="h-8 md:h-12 w-auto cursor-pointer"
                />
              </a>
            </div>

            <nav className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('process')}
                className="text-slate-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                진행 절차
              </button>
              <button 
                onClick={() => scrollToSection('testimonials')}
                className="text-slate-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                고객 후기
              </button>
              <button 
                onClick={() => scrollToSection('faq')}
                className="text-slate-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                FAQ
              </button>
              <button 
                onClick={() => scrollToSection('consulting-form')}
                className="bg-blue-600 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
              >
                무료 상담
              </button>
            </nav>

            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden text-slate-700 cursor-pointer"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="fixed inset-0 bg-black/50" onClick={() => setIsMobileMenuOpen(false)}></div>
          <nav className="fixed top-16 right-0 bottom-0 w-64 bg-white shadow-xl p-6">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('process')}
                className="text-slate-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap text-left py-3 border-b border-slate-200"
              >
                진행 절차
              </button>
              <button 
                onClick={() => scrollToSection('testimonials')}
                className="text-slate-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap text-left py-3 border-b border-slate-200"
              >
                고객 후기
              </button>
              <button 
                onClick={() => scrollToSection('faq')}
                className="text-slate-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap text-left py-3 border-b border-slate-200"
              >
                FAQ
              </button>
              <button 
                onClick={() => scrollToSection('consulting-form')}
                className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap text-center mt-4"
              >
                무료 상담
              </button>
            </div>
          </nav>
        </div>
      )}
    </>
  );
}
